import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import LinkButton from '../atoms/button/LinkButton';

const ModalConfirmFreeReservation = ({ open, onClose, onReserve }) => {

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="captionModal"
      bodyClassName="cautionModalBody"
      overlayClassName="cautionModalOverlay"
      customHeader={() => (
        <div className="captionModalHeader">
          <div className="cautionModalHeaderTitle" />
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
      shouldCloseOnOverlayClick={false}
    >
      <div>
        全額ギフトカード利用で予約確定します。<br />
        よろしいですか？
      </div>
      <div className="conformActions">
        <LinkButton buttonType="navigate actionButton" onClick={onClose}>いいえ</LinkButton>
        <LinkButton buttonType="cta actionButton" onClick={onReserve}>はい</LinkButton>
      </div>
    </Modal>
  );
};

ModalConfirmFreeReservation.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onReserve: PropTypes.func.isRequired,
};

export default ModalConfirmFreeReservation;
